export default __webpack_public_path__ + "19b632d.png";